// extracted by mini-css-extract-plugin
module.exports = {"title":"texts_title__KD_rC","hero":"texts_hero__qj1ZG","subtitle":"texts_subtitle__hk5pL","titleSubtitleWrapper":"texts_titleSubtitleWrapper__0b0ah"};